import React from "react";
import { CheckCircle2, Info, ListChecks } from "lucide-react";
import { getCalculatorGuide } from "./calculatorTranslations";

export default function CalculatorExplanation({ tool, lang = "en" }) {
  const guide = getCalculatorGuide(tool.slug, lang);

  return (
    <section className="mt-8 grid gap-6 lg:grid-cols-[1fr_20rem]">
      <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5 md:p-8">
        <p className="text-sm font-black uppercase tracking-[0.22em] text-primary">{guide.eyebrow}</p>
        <h2 className="mt-3 font-heading text-3xl font-black md:text-4xl">{guide.title}</h2>
        <p className="mt-4 text-lg leading-8 text-muted-foreground">{guide.summary}</p>
        <div className="mt-6 space-y-5 text-base leading-8 text-foreground/82">
          {guide.explanation.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
      </article>

      <aside className="space-y-4">
        <div className="rounded-[2rem] border border-primary/20 bg-primary/10 p-6">
          <h3 className="flex items-center gap-2 text-lg font-black"><ListChecks className="h-5 w-5 text-primary" /> {guide.labels.howToUse}</h3>
          <div className="mt-4 space-y-3">
            {guide.steps.map((step, index) => (
              <div key={step} className="flex gap-3 rounded-2xl bg-card/80 p-3 text-sm font-semibold leading-6">
                <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-primary text-xs font-black text-primary-foreground">{index + 1}</span>
                <span>{step}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-[2rem] border border-border bg-card p-6">
          <h3 className="flex items-center gap-2 text-lg font-black"><Info className="h-5 w-5 text-primary" /> {guide.labels.bestFor}</h3>
          <div className="mt-4 space-y-2">
            {guide.bestFor.map((item) => (
              <div key={item} className="flex items-center gap-2 text-sm font-bold text-muted-foreground">
                <CheckCircle2 className="h-4 w-4 text-primary" /> {item}
              </div>
            ))}
          </div>
        </div>
      </aside>
    </section>
  );
}